<div class="product-summary-root">
    <div class="body">
        <div class="product-card">
          <ng-container *ngIf="showDefaultImage; else productImage">
            <div class="card-default-image">
              <nb-icon icon="printer-outline"></nb-icon>
            </div>
          </ng-container>
          <ng-template #productImage>
            <img src="{{ product.image }}" alt="productImg"
                 (error)="showDefaultImage = true"/>
          </ng-template>
          <div class="product-details">
            <span class="product-name" title="{{ product.name }}">{{ product.name }}</span>
            <span class="product-info">{{ labels.participatingProduct }}</span>
          </div>
        </div>

        <div class="information">
          <div class="info-row">
            <span><strong>{{ labels.printerHeadersNote }}*:</strong></span>
            <span>{{ formattedHeaders }}</span>
          </div>
          <div class="info-row">
            <span><strong>{{ labels.printerFamilyNote }}*:</strong></span>
            <span>{{ product.family }}</span>
          </div>
        </div>
    </div>

    <div class="footer">
      <p [innerHTML]="labels.productReview"></p>
      <p class="note">{{ labels.printerNote }}</p>
    </div>
  </div>
